var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1064 3.27002H2.00006V12.5762H13.1064V3.27002Z",
    stroke: "#474C55",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00709 1H5V4.75442C5 5.43905 4.10638 6 3 6C1.90071 6 1 5.44346 1 4.75442V1H1.00709Z",
    fill: "white",
    stroke: "#474C55",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00887 1H10V4.75442C10 5.43905 8.88298 6 7.5 6C6.12589 6 5 5.44346 5 4.75442V1H5.00887Z",
    fill: "white",
    stroke: "#474C55",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0071 1H14V4.75442C14 5.43905 13.1064 6 12 6C10.9007 6 10 5.44346 10 4.75442V1H10.0071Z",
    fill: "white",
    stroke: "#474C55",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3899 8.14258H7.90564V12.5761H10.3899V8.14258Z",
    stroke: "#474C55",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStore);
export default __webpack_public_path__ + "static/media/icon_store.e2fb4c561d6ba83577ab1ba14e83356f.svg";
export { ForwardRef as ReactComponent };